import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMildIrritationEmoji(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8 24c0-8.2-6.7-14.8-14.8-14.8-8.1 0-14.8 6.7-14.8 14.8 0 8.1 6.7 14.8 14.8 14.8 8.1 0 14.8-6.6 14.8-14.8ZM8 24c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16S8 32.8 8 24Zm24.6-.7a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM33 29a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-1.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM35 29a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-21.3-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5.8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.2-4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm4.2 5.125h6.6v-1.25h-6.6v1.25Z",
    fill: "currentColor"
  }));
}

export { SvgMildIrritationEmoji as default };
